export default {
      id: "reefer-error-usage",
      viewBox: "0 0 34 33",
      url: __webpack_public_path__ + "img/icons.svg#reefer-error",
      toString: function () {
        return this.url;
      }
    }